const AppCatalogActions = {
  SET_APP_DETAIL: 'SET_APP_DETAIL',
  CLEAR_APP_DETAIL: 'CLEAR_APP_DETAIL',
  SET_CURR_REGION: 'SET_CURR_REGION',
  CLEAR_CURR_REGION: 'CLEAR_CURR_REGION',
  SET_REGION_LIST: 'SET_REGION_LIST'
}

export default AppCatalogActions
